import { render, staticRenderFns } from "./areCancell.vue?vue&type=template&id=c71ce5a2&scoped=true&"
import script from "./areCancell.vue?vue&type=script&lang=js&"
export * from "./areCancell.vue?vue&type=script&lang=js&"
import style0 from "./areCancell.vue?vue&type=style&index=0&id=c71ce5a2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c71ce5a2",
  null
  
)

export default component.exports